import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import pdf from "../../Assets/Javascript-Certificate.pdf";
import pdf2 from "../../Assets/Internship Completion Certificate - Iftikar Hussain.pdf";
import pdf3 from "../../Assets/Git & GitHub Certiicate.pdf";
import pdf4 from "../../Assets/React Bootcamp Certificate.pdf";
import { Document, Page, pdfjs } from "react-pdf";
import { PiCertificateDuotone } from "react-icons/pi";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { Helmet } from "react-helmet";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <>
      <Helmet>
        <title>Resume | Iftikhar Hussain | SpidyCoder</title>
        <meta
          name="description"
          content="Self-taught developer creating professional, modern websites and apps with a passion for learning and growth."
        />
        <link
          rel="canonical"
          href="https://iftikhariscoding.netlify.app/resume"
        />
      </Helmet>
      <Container fluid className="resume-section">
        <Particle />
        {/* <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            style={{ maxWidth: "150px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row> */}
        <h1 style={{ marginTop: 20, marginBottom: 5 }}>
          <span className="purple">
            {" "}
            <PiCertificateDuotone />{" "}
          </span>
          <b>Certificates</b>
        </h1>

        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          {[pdf, pdf2, pdf3, pdf4].map((pdfFile, index) => (
            <Col md={6} lg={4} key={index} style={{ marginBottom: "30px", display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div className="resume d-flex justify-content-center">
                <Document
                  file={pdfFile}
                  className="d-flex justify-content-center"
                >
                  <Page
                    pageNumber={1}
                    scale={width > 992 ? 0.45 : width > 786 ? 0.5 : 0.45}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                  />
                </Document>
              </div>
              {/* <<<<<<<----------------------Download Botton------------------------->>>>>>>>> */}
              {/* <Button
                variant="primary"
                href={pdfFile}
                target="_blank"
                style={{ maxWidth: "250px", marginTop: "20px" }}
              >
                <AiOutlineDownload />
                &nbsp;Download Certificate
              </Button> */}
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
}

export default ResumeNew;
